import { environmentSelector } from '@selectors/commonSelectors';
import useAppSelector from './useAppSelector';

export const useAccountActivityState = () => {
    const { isState, localDates } = useAppSelector(environmentSelector);

    // Extract timezone info for timestamp conversion
    // Use nullish coalescing (??) to correctly handle numeric 0 values
    const timezoneInfo = {
        timezoneOffsetMs: parseInt(localDates?.timezoneOffsetMs ?? '0', 10),
        dstSavingsMs: parseInt(localDates?.dstSavingsMs ?? '0', 10),
        timezone: localDates?.timezone ?? '',
    };

    const defaultValues = {
        isLinkForEventName: true,
        borderSize: '2px',
        timezoneInfo,
    };

    switch (true) {
        case isState.ID:
        case isState.NJ:
        case isState.NV:
            return {
                ...defaultValues,
                borderSize: '1px',
            };
        case isState.MN:
            return {
                ...defaultValues,
                isLinkForEventName: false,
                borderSize: '1px',
            };
        default:
            return defaultValues;
    }
};
